import React from 'react';
import { cn } from '../lib/utils';

const StatCard = ({ title, value, delta, icon: IconComponent, accent = 'blue', compact = false }) => {
  const accentStyles = {
    blue: {
      bg: 'bg-[rgba(47,123,255,0.20)]',
      text: 'text-[var(--ds-accent-primary)]',
    },
    green: {
      bg: 'bg-[var(--ds-status-success-bg)]',
      text: 'text-[var(--ds-status-success)]',
    },
    orange: {
      bg: 'bg-[rgba(242,201,76,0.20)]',
      text: 'text-[var(--ds-status-warning)]',
    },
    purple: {
      bg: 'bg-[rgba(139,92,246,0.20)]',
      text: 'text-[#8B5CF6]',
    },
    yellow: {
      bg: 'bg-[var(--ds-status-warning-bg)]',
      text: 'text-[var(--ds-status-warning)]',
    },
    red: {
      bg: 'bg-[var(--ds-status-danger-bg)]',
      text: 'text-[var(--ds-status-danger)]',
    },
  };

  const accentStyle = accentStyles[accent] || accentStyles.blue;

  return (
    <div className={cn(
      'bg-[var(--ds-surface-panel)]',
      'border border-[var(--ds-border-subtle)]',
      'rounded-[var(--ds-radius-lg)]',
      'shadow-[var(--ds-shadow-card)]',
      compact ? 'p-3' : 'p-5'
    )}>
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <p
            className="font-medium text-[11px] leading-tight text-[var(--ds-text-muted)]"
          >
            {title}
          </p>
          <p
            className={cn(
              'font-bold text-[var(--ds-text-primary)] tabular-nums',
              compact ? 'text-lg mt-1' : 'text-3xl mt-2'
            )}
          >
            {value}
          </p>
          {delta !== undefined && (
            <p
              className={cn(
                compact ? 'mt-1 text-[10px] leading-tight' : 'mt-2 text-[10px] leading-tight',
                'text-ds-status-warning'
              )}
            >
              {delta >= 0 ? '+' : ''}{delta}% vs last month
            </p>
          )}
        </div>
        {IconComponent && (
          <div className={cn(
            'flex-shrink-0',
            'h-12 w-12',
            'rounded-[var(--ds-radius-md)]',
            'flex items-center justify-center',
            accentStyle.bg
          )}>
            <IconComponent className={cn('h-6 w-6', accentStyle.text)} aria-hidden />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;


